import { Tool } from "lib/types/Tool";
import { useCesium } from "../useCesium";
import { useSyncCesium } from "../useSyncCesium";

export function useActiveTool() {
  const { toolManager } = useCesium();
  const activeTool = useSyncCesium(toolManager.activeTool);

  return {
    activeTool,
    setActiveTool: (tool: Tool) => toolManager.setActiveTool(tool),
  };
}
